import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import { Button, rem } from 'design-system';
import IconPot from 'design-system/icons/IconPot';
import IconCircle from 'design-system/icons/IconCircle';
import useStyles from 'hooks/useStyles';
import { useTabNavigation } from 'hooks/navigation/useTabNavigation';
import createStyleSheets from 'utils/createStyleSheets';
import { useAppSelector, useAppStore } from 'store/hooks';
import { OnboardingFlow } from 'utils/types/navigation';
import { selectUserTier } from 'features/premium/selectors/tier';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useNavigateToCreatePot from 'features/pots/hooks/useNavigateToCreatePot';
import { selectIsPotsAccountActive, selectPotProductFromProductId, } from 'features/pots/reducers/selectors';
import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
import { isWeb } from '../../../constants';
const UnopenedPotItem = ({ data }) => {
    const { productId, productName } = data;
    const store = useAppStore();
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const { navigateToTab } = useTabNavigation();
    const navigateToCreatePot = useNavigateToCreatePot();
    const activeTier = useAppSelector(selectUserTier);
    const isPotAccountActive = useAppSelector(selectIsPotsAccountActive);
    const interestPotProductsTierRateMap = useAppSelector((store) => store.pots.interestPotProductsTierRateMap);
    const rateToDisplay = interestPotProductsTierRateMap?.[productId]?.[activeTier];
    const onPress = useCallback(() => {
        if (isWeb) {
            UnavailableOnWebModal.show('emma://save?tab=pots', 'Create a Pot');
            return;
        }
        if (!isPotAccountActive) {
            navigateToTab('Save', { tab: 'pots' });
            return;
        }
        const state = store.getState();
        const isCashIsa = selectPotProductFromProductId(state, productId)?.isProductCashISA;
        if (isCashIsa && !state.user.user.taxId) {
            navigation.navigate('InvestInsurance', {
                flow: OnboardingFlow.Pots,
                productId,
            });
            return;
        }
        navigateToCreatePot(productId);
    }, [
        isPotAccountActive,
        navigateToCreatePot,
        navigateToTab,
        navigation,
        productId,
        store,
    ]);
    return (<View style={styles.container}>
      <IconCircle width={44} height={44}>
        <IconPot />
      </IconCircle>
      <View style={styles.flex}>
        <Text Text-16 numberOfLines={1}>
          {productName}
        </Text>
        {!!rateToDisplay && (<Text TextThin-14 Secondary>
            <Text NumbersThin-14 Secondary>
              {rateToDisplay}%
            </Text>{' '}
            AER
          </Text>)}
      </View>
      <Button square hug onPress={onPress} brandReversed title="Create"/>
    </View>);
};
const styleSet = createStyleSheets(() => ({
    container: {
        gap: rem(16),
        padding: rem(16),
        flexDirection: 'row',
        alignItems: 'center',
        ...(isWeb && {
            paddingHorizontal: rem(8),
        }),
    },
    flex: {
        flex: 1,
    },
}));
export default memo(UnopenedPotItem);
